import PlentyApiClient from "./base";

export const sheetsSettingsApi = {
  // Get current sheets settings for Penner or Renner
  getSettings: (type) => {
    return PlentyApiClient.get("/sheets/settings", {
      params: { type },
    });
  },

  // Update sheets settings (partial or complete update) for Penner or Renner
  updateSettings: (settings, type) => {
    return PlentyApiClient.post("/sheets/settings", settings, {
      params: { type },
    });
  },

  // Reset sheets settings to defaults for Penner or Renner
  resetSettings: (type) => {
    return PlentyApiClient.delete("/sheets/settings", {
      params: { type },
    });
  },

  // Save sheets settings (alias for updateSettings for compatibility)
  saveSettings: (type, settings) => {
    return PlentyApiClient.post("/sheets/settings", settings, {
      params: { type },
    });
  },

  // Clear sheets settings (alias for resetSettings for compatibility)
  clearSettings: (type) => {
    return PlentyApiClient.delete("/sheets/settings", {
      params: { type },
    });
  },
};
